import React from 'react';

import { Stats as StatsComponent, componentTypes } from '@white-nl/instantsearch-components';

export default function Stats({
  stats,
  results,
  statsSettings,
  additionalData,
}: componentTypes.StatsProps) {
  // eslint-disable-next-line no-underscore-dangle
  if (results.__isArtificial) {
    return null;
  }

  return (
    <StatsComponent
      stats={stats}
      results={results}
      statsSettings={statsSettings}
      additionalData={additionalData}
    />
  );
}
